import Enum from '../interfaces/IEnum';

export const CriteriaTypes: Enum = {
    enum: {
        EXAMID: 0,
        NUMEXAMPASSED: 1,
        NOCRITERIA: 2
    }
};
